import React from "react";
import { Line } from "react-chartjs-2";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import statsStyles from "../styles/StatsSection.module.css";
import { formatMoney } from "../utils/formatters";
import { buildRegistrationsChartData } from "../utils/chartUtils";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

function StatsSectionBody({ stats }) {
  const planPrices = stats?.planPrices || {};
  const breakdown = stats?.premiumStats?.breakdown || {};
  const paidRevenueEstimate = stats?.premiumStats?.paidRevenueEstimate ?? null;
  const totalRevenueEstimate = stats?.premiumStats?.totalRevenueEstimate ?? null;
  const planPricesText =
    Number(planPrices.lite || 0) || Number(planPrices.pro || 0) || Number(planPrices.max || 0)
      ? `${formatMoney(planPrices.lite)} / ${formatMoney(planPrices.pro)} / ${formatMoney(planPrices.max)}`
      : "—";
  const chartData = buildRegistrationsChartData(stats?.registrations || []);

  const paidCount =
    (breakdown?.paid?.lite?.count || 0) + (breakdown?.paid?.pro?.count || 0) + (breakdown?.paid?.premium?.count || 0);
  const giftedCount =
    (breakdown?.gifted?.lite?.count || 0) + (breakdown?.gifted?.pro?.count || 0) + (breakdown?.gifted?.premium?.count || 0);
  const unknownCount =
    (breakdown?.unknown?.lite?.count || 0) + (breakdown?.unknown?.pro?.count || 0) + (breakdown?.unknown?.premium?.count || 0);
  const legacyCount =
    (breakdown?.legacy?.lite?.count || 0) + (breakdown?.legacy?.pro?.count || 0) + (breakdown?.legacy?.premium?.count || 0);
  const confirmedActive = paidCount + giftedCount;
  const totalActive = (stats?.premiumUsers || 0) || confirmedActive + unknownCount + legacyCount;

  return (
    <>
      <div className={statsStyles.cards}>
        <div className={statsStyles.card}>
          <div className={panelStyles.note}>Регистрации за 7 дней</div>
          <div>{(stats?.registrations || []).join(", ")}</div>
        </div>
        <div className={statsStyles.card}>
          <div className={panelStyles.note}>Активные за 24 часа</div>
          <div>{stats?.dailyActive || 0}</div>
        </div>
        <div className={statsStyles.card}>
          <div className={panelStyles.note}>Всего пользователей</div>
          <div>{stats?.totalUsers || 0}</div>
        </div>
        <div className={statsStyles.card}>
          <div className={panelStyles.note}>Премиум-пользователи</div>
          <div>
            Lite {stats?.lite?.count || 0}, Pro {stats?.pro?.count || 0}, Max {stats?.premium?.count || 0}
          </div>
          <div className={panelStyles.note}>
            Активные: подтверждённые {confirmedActive} (платные {paidCount}, подарочные {giftedCount}), legacy {legacyCount}, неизвестно {unknownCount}.
          </div>
        </div>
        <div className={joinClasses(statsStyles.card, statsStyles.total)}>
          <div className={panelStyles.note}>Оценка выручки (платные подписки)</div>
          <div>{typeof paidRevenueEstimate === "number" ? formatMoney(paidRevenueEstimate) : "—"}</div>
          <div className={panelStyles.note}>Всего активных (включая подарочные): {typeof totalRevenueEstimate === "number" ? formatMoney(totalRevenueEstimate) : "—"}</div>
          <div className={panelStyles.note}>Расчёт: активные подписки × фиксированные цены ({planPricesText}).</div>
        </div>
      </div>

      <div className={statsStyles.chartWrap}>
        <Line
          data={{
            labels: chartData.labels,
            datasets: [
              {
                label: "Регистрации",
                data: chartData.data,
                borderColor: "rgba(124, 231, 255, 1)",
                backgroundColor: "rgba(124, 231, 255, 0.18)"
              }
            ]
          }}
          options={{ responsive: true }}
        />
      </div>
    </>
  );
}

export function StatsSection({ mode = "panel", isOpen = true, onToggle, stats }) {
  if (mode === "page") {
    return <StatsSectionBody stats={stats} />;
  }

  return (
    <AdminPanel id="stats" title="Статистика" isOpen={isOpen} onToggle={onToggle}>
      <StatsSectionBody stats={stats} />
    </AdminPanel>
  );
}

export default StatsSection;
